export const DefaultSessionReferenceFormat = 'BRZ-{date:datetime:yyyymmdd}-{#:4}'